import React, { useState, useEffect } from "react";
import { PlusCircle, Edit, Trash2, Eye } from "react-feather";
import { useForm, FormProvider } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { yupResolver } from "@hookform/resolvers/yup";
import { endOfMonth, format, startOfMonth } from "date-fns";
import { json, useNavigate } from "react-router-dom";
import { all_routes } from "Router/all_routes";
import ToastNotification from "Components/UI/ToastNotification";
import { Link } from "react-router-dom";
import {
  useApproveLeaveMutation,
  useRejectLeaveMutation,
} from "AppQuries/leave/apply-leave";
import Swal from "sweetalert2";
import Error404 from "MainPages/ErrorPages/error404";
import { useTableSearch } from "core/Operations/useTableSearch";
import { useGetEmployeeQuery } from "AppQuries/employee/employee_list";
import { useGetEmployeeLeaveQuery } from "AppQuries/leave/get-emp-leaves";
import TableTop from "Components/UI/TableTop";
import { Table } from "antd";
import { DatePicker } from "antd";
import Select from "react-select";
import { DisabledDate } from "core/Operations/disableDates";
const { RangePicker } = DatePicker;
import dayjs from "dayjs";
import ReportTools from "Components/UI/ReportTools";
import { useGetAllDepartmentQuery } from "AppQuries/master/Department/get-all-departments";
import { render } from "@fullcalendar/core/preact";
import { useGetEmpAppliedLeaveQuery } from "AppQuries/leave/applied-leave-detail";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ImagePreview from "Components/UI/Image/ImagePreview";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import Can from "core/Operations/Can";
import { accessCodes } from "core/json/accessCode";
import { useGetUnAppliedLeave } from "AppQuries/leave/get-un-applied-leave";
const UnAppliedLeaveList = () => {
  const userData = useSelector(loggedInUser);
  const navigate = useNavigate();
  const [isMount, setIsMount] = useState(false);

  const { mutate: approveLeave } = useApproveLeaveMutation();
  const { mutate: rejectLeave } = useRejectLeaveMutation();
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const [queryParams, setQueryParams] = useState({
    employeeCode: 0,
    departmentCode: 0,
    leaveCode: 0,
    fromDate: format(new Date(), "yyyy-MM-dd"),
    toDate: format(new Date(), "yyyy-MM-dd"),
  });

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };
  const { data, isError, error, isLoading, isFetching, refetch } =
    useGetUnAppliedLeave(
      {
        ...queryParams,
        companyCode: userData?.companyCode,
        locationCode: userData?.selectedLocationCode,
        userId: userData?.userID,
        isAllCompanies: userData?.isAllCompanies,
        selectedCompanyCode: userData?.selectedCompanyCode,
      },
      {
        enabled: Boolean(
          queryParams.employeeCode &&
          queryParams.departmentCode &&
          userData?.companyCode,
        ),
      },
    );
  const leaveData = data?.map((d, id) => ({
    ...d,
    id: id + 1,
    absentDate: format(new Date(d.absentDate), "dd-MM-yyyy"),
  }));

  const { data: employees, refetch: getEmployee } = useGetEmployeeQuery({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
    departmentCode: queryParams?.departmentCode,
    isAll: false,
  });
  const { data: departments } = useGetAllDepartmentQuery({
    companyCode: userData?.companyCode,
    isTrue: true,
  });

  const departmentOptions = Array.isArray(departments?.data)
    ? departments?.data
        .filter((d) => d.isActive)
        .map((o) => ({
          id: o.code,
          label: o.description,
          value: o.code,
        }))
    : [];

  const employeeOptions = Array.isArray(employees)
    ? employees
        ?.filter((d) => d.isActive)
        .map((o) => ({
          id: o.employeeCode,
          label: `${o.uniqueId} - ${o.fullName}`,
          value: o.employeeCode,
        }))
    : [];

  const updateQueryParams = (key, value) => {
    setQueryParams((prev) => ({ ...prev, [key]: value }));
  };

  const confirmApprove = (id) => {
    Swal.fire({
      title: "Approve Leave?",
      text: "Are you sure to Approve this leave",
      type: "warning",
      showCancelButton: !0,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Approve it!",
      confirmButtonClass: "btn btn-primary",
      cancelButtonClass: "btn btn-danger ml-1",
      buttonsStyling: 1,
    }).then(function (t) {
      if (t.isConfirmed) {
        const payload = {
          companyCode: userData.companyCode,
          leaveId: id,
          isApproved: 1,
          approvedBy: userData.userName,
          approvedDate: format(new Date(), "yyyy-MM-dd"),
          modifyUser: userData.userName,
        };

        approveLeave(payload, {
          onSuccess: (data) => {
            if (data?.data[0].response === true) {
              refetch();
              Swal.fire({
                type: "success",
                title: "Leave Approved !",
                text: "Leave Approved Successfully..",
                confirmButtonClass: "btn btn-success",
              });
            } else {
              Swal.fire({
                title: "Warning!",
                text: data?.data[0].errorMessage,
                type: "warning",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Ok",
                confirmButtonClass: "btn btn-primary",
                okButtonClass: "",
                buttonsStyling: 1,
              });
            }
          },
          onError: (error) => {
            let message = error.message || "Something went wrong.";
            Swal.fire({
              title: "Warning!",
              text: message,
              type: "warning",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Ok",
              confirmButtonClass: "btn btn-primary",
              okButtonClass: "",
              buttonsStyling: 1,
            });
          },
        });
      }
    });
  };

  const confirmDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      type: "warning",
      showCancelButton: !0,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      confirmButtonClass: "btn btn-primary",
      cancelButtonClass: "btn btn-danger ml-1",
    }).then(function (t) {
      if (t.isConfirmed) {
        const payload = {
          companyCode: userData.companyCode,
          leaveId: id,
          isApproved: 2,
          approvedBy: userData.userName,
          approvedDate: format(new Date(), "yyyy-MM-dd"),
          modifyUser: userData.userName,
        };

        approveLeave(payload, {
          onSuccess: (data) => {
            if (data?.data[0].response === true) {
              refetch();
              Swal.fire({
                type: "success",
                title: "Leave Deleted !",
                text: "Leave Deleted Successfully..",
                confirmButtonClass: "btn btn-success",
              });
            } else {
              Swal.fire({
                title: "Warning!",
                text: data?.data[0].errorMessage,
                type: "warning",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Ok",
                confirmButtonClass: "btn btn-primary",
                okButtonClass: "",
              });
            }
          },
          onError: (error) => {
            let message = error.message || "Something went wrong.";
            Swal.fire({
              title: "Warning!",
              text: message,
              type: "warning",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Ok",
              confirmButtonClass: "btn btn-primary",
              okButtonClass: "",
            });
          },
        });
      }
    });
  };

  const columns = [
    {
      title: "Emp Code",
      dataIndex: "uniqueID",
      key: "uniqueID",
      // sorter: (a, b) => a.leaveType.length - b.leaveType.length,
    },
    {
      title: "Emp Name",
      dataIndex: "employeeName",
      sorter: (a, b) => a.employeeName.length - b.employeeName.length,
      fixed: "left",
      render: (text, record) => (
        // <div className="userimgname">
        //   <div>
        <Link
          to={`${all_routes.employee}${all_routes.employee_view}/${record.employeeCode}`}
        >
          {text}
        </Link>
        // <span className="emp-team">{record.uniqueID}</span>
        //   </div>
        // </div>
      ),
    },

    {
      title: "Deoartment Name",
      dataIndex: "departmentName",
      sorter: (a, b) => a.departmentName.length - b.departmentName.length,
      // render: (text, record) => <>{format(new Date(text), "dd-MM-yyyy")}</>,
    },
    {
      title: "Absent Date",
      dataIndex: "absentDate",
      sorter: (a, b) => a.absentDate.length - b.absentDate.length,
      // render: (text, record) => <>{format(new Date(text), "dd-MM-yyyy")}</>,
    },
  ];

  const downloadColumns = columns.filter(
    (column) => column.dataIndex !== "imageAttachment",
  );

  const searchColumns = columns.map((column) => column.dataIndex);
  const { setSearchValue, filteredData } = useTableSearch(
    leaveData,
    searchColumns,
  );

  useEffect(() => {
    if (isMount) getEmployee();

    setIsMount(true);
  }, [queryParams?.departmentCode]);

  if (isError) {
    return <Error404 error={error} />;
  }

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Leave Management</h4>
                <h6>Manage employees request, approved and rejected leaves</h6>
              </div>
            </div>

            <ReportTools
              columns={downloadColumns}
              data={filteredData}
              fileName={`Un Applied Leave Report ${queryParams.fromDate} - ${queryParams.toDate}`}
              pdfTheme="striped"
              refresh={refetch}
            />
            {!userData?.isAllCompanies && (
              <div className="page-btn">
                <Can
                  accessModule={accessCodes.leave_adjustment}
                  accessCode={accessCodes.leave_management}
                  accessType="haveAdd"
                >
                  <Link
                    to={`${all_routes.leave}${all_routes.apply_leave}`}
                    className="btn btn-added"
                  >
                    <PlusCircle className="me-2" />
                    Apply Leave
                  </Link>
                </Can>
              </div>
            )}
          </div>
          <div className="card border-0">
            <div className="card-body">
              <TableTop
                onSearch={setSearchValue}
                toggleFilterVisibility={toggleFilterVisibility}
                isFilterVisible={isFilterVisible}
                showToggle={true}
              />
              <div
                className={`card${isFilterVisible ? " visible" : ""}`}
                id="filter_inputs"
                // style={{ display: isFilterVisible ? "block" : "none" }}
              >
                <div className="form-row row">
                  <div className="row">
                    <div className="col-lg-3 col-sm-6 col-12 mb-3">
                      <div className="form-group">
                        <label className="form-label">
                          Start Date – End Date
                        </label>
                        <RangePicker
                          disabledDate={DisabledDate}
                          className="form-control"
                          style={{ display: "flex" }}
                          onChange={(date, dateFormat) => {
                            updateQueryParams("fromDate", dateFormat[0]);
                            updateQueryParams("toDate", dateFormat[1]);
                          }}
                          defaultValue={[
                            dayjs(queryParams?.fromDate, "YYYY-MM-DD"),
                            dayjs(queryParams?.toDate, "YYYY-MM-DD"),
                          ]}
                          format="YYYY-MM-DD"
                          allowClear={false}
                        />
                      </div>
                    </div>
                    <div className="col-lg-3 col-sm-6 col-12 mb-3">
                      <div className="form-group">
                        <label className="form-label">Department</label>
                        <Select
                          className="select"
                          options={departmentOptions}
                          placeholder="Department"
                          value={departmentOptions.find(
                            (option) =>
                              option.value === queryParams.departmentCode,
                          )}
                          onChange={(e) => {
                            updateQueryParams("departmentCode", e?.value || 0);
                          }}
                          isClearable
                          styles={{
                            // control: (baseStyles, state) => ({
                            //   ...baseStyles,
                            //   width: "200px",
                            // }),
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999999999,
                            }),
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-lg-3 col-sm-6 col-12 mb-3">
                      <div className="form-group">
                        <label className="form-label">Employee</label>
                        <Select
                          className="select"
                          options={employeeOptions}
                          placeholder="Select Employee"
                          value={
                            employeeOptions.find(
                              (option) =>
                                option.value === queryParams.employeeCode,
                            ) || ""
                          }
                          onChange={(e) => {
                            updateQueryParams("employeeCode", e?.value || 0);
                          }}
                          isClearable
                        />
                      </div>
                    </div>

                    <div className="col-lg-3 col-sm-6 col-12">
                      <div className="input-blocks">
                        <label className="form-label">&nbsp;</label>
                        <Link
                          className="btn btn-filters ms-auto"
                          onClick={refetch}
                          type="button"
                        >
                          <i data-feather="search" className="feather-search" />
                          {isFetching ? (
                            <>
                              <i className="fas fa-spinner fa-spin me-2"></i>
                              Loading...
                            </>
                          ) : (
                            <>Filter</>
                          )}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="table-responsive" id="pdfPrint">
                <Table
                  className="table  datanew"
                  columns={columns}
                  dataSource={filteredData}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnAppliedLeaveList;
